"use strict";
// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Fpowerpoint-session-protocol%2Fsrc%2Fmessages.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
Object.defineProperty(exports, "__esModule", { value: true });
exports.PowerPointSessionExtensionConfig = exports.PowerPointSessionInitMessage = void 0;
var types_core_1 = require("@augloop/types-core");
var PowerPointSessionInitMessage = /** @class */ (function () {
    function PowerPointSessionInitMessage(obj) {
        types_core_1.SchemaObject.assign(PowerPointSessionInitMessage, this, obj);
    }
    PowerPointSessionInitMessage.getTypeName = function () {
        return 'AugLoop_Powerpoint_Session_Protocol_PowerPointSessionInitMessage';
    };
    PowerPointSessionInitMessage.getBaseTypes = function () {
        return ['AugLoop_Session_Protocol_SessionInitMessage', 'AugLoop_Session_Protocol_Message'];
    };
    PowerPointSessionInitMessage.H_ = { T_: PowerPointSessionInitMessage.getTypeName(), B_: PowerPointSessionInitMessage.getBaseTypes() };
    return PowerPointSessionInitMessage;
}());
exports.PowerPointSessionInitMessage = PowerPointSessionInitMessage;
var PowerPointSessionExtensionConfig = /** @class */ (function () {
    function PowerPointSessionExtensionConfig(obj) {
        types_core_1.SchemaObject.assign(PowerPointSessionExtensionConfig, this, obj);
    }
    PowerPointSessionExtensionConfig.getTypeName = function () {
        return 'AugLoop_Powerpoint_Session_Protocol_PowerPointSessionExtensionConfig';
    };
    PowerPointSessionExtensionConfig.getBaseTypes = function () {
        return [];
    };
    PowerPointSessionExtensionConfig.H_ = { T_: PowerPointSessionExtensionConfig.getTypeName(), B_: PowerPointSessionExtensionConfig.getBaseTypes() };
    return PowerPointSessionExtensionConfig;
}());
exports.PowerPointSessionExtensionConfig = PowerPointSessionExtensionConfig;
//# sourceMappingURL=messages.g.js.map